module.exports = __webpack_public_path__ + "static/media/prism-1.263542d6.mp3";